const navs = [
  {
    active: false,
    label: 'Pracownicy',
    routeName: 'dashboard',
    icon: 'icon_dashboard_',
    permission: ['admin_director', 'chief', 'department_director'],
  },
  {
    active: false,
    label: 'Utwórz',
    icon: 'icon_utworznowy_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
    ],
    children: {
      icon: 'icon_nowa_G_B_K_',
      routes: [
        {
          active: false,
          label: 'Nowy Projekt',
          routeName: 'create-project',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
        {
          active: false,
          label: 'Nowy Akcydens NBP',
          routeName: 'create-commercial-print',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
        {
          active: false,
          label: 'Nowy wniosek DKO',
          routeName: 'create-dko',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
        {
          active: false,
          label: 'Nowy Wniosek KIW',
          routeName: 'create-kiw',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      ],
    },
  },
  {
    active: false,
    label: 'Projekty',
    icon: 'icon_projkty_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
    ],
    children: {
      icon: 'icon_projkty_',
      routes: [
        {
          active: false,
          label: 'Lista projektów',
          routeName: 'projects-index',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
        {
          active: false,
          label: 'Projekty do akceptacji',
          routeName: 'quick-acceptance',
          permission: ['admin_director', 'chief', 'department_director'],
        },
        {
          active: false,
          label: 'Projekty wymagające akcji',
          routeName: 'required-action-projects',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
        {
          active: false,
          label: 'Moje projekty',
          routeName: 'my-projects',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
        {
          active: false,
          label: 'Usunięte projekty',
          icon: 'icon_basket_',
          routeName: 'trash',
          permission: ['admin_director', 'chief', 'department_director'],
        },
        {
          active: false,
          label: 'Kampanie',
          routeName: 'campaigns',
          icon: 'icon_dashboard_',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      ],
    },
  },
  {
    active: false,
    label: 'Akcydensy NBP',
    routeName: 'commercial-print-index',
    icon: 'icon_projkty_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
  },
  {
    active: false,
    label: 'Współpraca DKO',
    routeName: 'dko-cooperation-index',
    icon: 'icon_projkty_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
  },
  {
    active: false,
    label: 'KIW',
    routeName: 'kiw-index',
    icon: 'icon_KIW_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
  },
  {
    active: false,
    label: 'Archiwum',
    icon: 'icon_archiwum_',
    routeName: 'archive-projects',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
  },
  {
    active: false,
    label: 'Administracja',
    icon: 'icon_uzytkownicy_',
    permission: [
      'admin_director',
      'chief',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
    children: {
      icon: 'icon_archive_',
      routes: [
        {
          active: false,
          label: 'Użytkownicy',
          routeName: 'admin-settings',
          permission: ['admin_director', 'chief', 'user_admin'],
        },
        {
          active: false,
          label: 'Tagi',
          routeName: 'tags',
          permission: ['admin_director', 'chief', 'user_admin'],
        },
        {
          active: false,
          label: 'Kalendarz nieobecności',
          routeName: 'replacements-calendar',
          permission: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      ],
    },
  },
  {
    active: false,
    label: 'Pomoc',
    routeName: 'help',
    icon: 'icon_pomoc_',
    permission: [
      'admin_director',
      'chief',
      'user_admin',
      'department_director',
      'user',
      'graphic',
      'editor',
      'project_manager',
      'print_coordinator',
      'guard',
      'other',
    ],
  },
];

export default navs;
